import type { Root } from 'mdast';
import type { VFile } from 'vfile';
import { visit } from 'unist-util-visit';

import { YOUTUBE_MDX_DIRECTIVE_NAME } from './youTubeMdxDirectiveConstants';

export const youTubeMdxDirectiveRemarkPlugin =
  () =>
  (tree: Root, file: VFile): void => {
    visit(tree, function (node) {
      if (node.type === 'leafDirective') {
        if (node.name !== YOUTUBE_MDX_DIRECTIVE_NAME) {
          return;
        }

        // eslint-disable-next-line no-param-reassign
        const data = node.data ?? (node.data = {});
        const attributes = node.attributes ?? {};
        const id = attributes.id;

        if (!id) {
          file.fail(
            `Unexpected missing \`id\` on \`${YOUTUBE_MDX_DIRECTIVE_NAME}\` directive.`,
            node,
          );
        }

        const url = `https://www.youtube.com/embed/${id}`;

        data.hName = 'iframe';
        data.hProperties = {
          src: url,
          width: 560,
          height: 315,
          title: 'YouTube video player',
          allow:
            'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
          referrerpolicy: 'strict-origin-when-cross-origin',
          allowfullscreen: true,
        };
      }
    });
  };
